module.exports = __webpack_public_path__ + "static/media/pagination-first.50c47b79.svg";